var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5.348h1.778m14.222 0h-1.778m-12.444 0 .683 13.751A2 2 0 0 0 8.46 21h7.082a2 2 0 0 0 1.998-1.9l.683-13.752m-12.444 0h3.555m8.89 0h-3.556m-5.334 0V4a1 1 0 0 1 1-1h3.334a1 1 0 0 1 1 1v1.348m-5.334 0h5.334M8.444 7.696 9 18.652m3-10.956v10.956m3.556-10.956L15 18.652",
    stroke: "#818C96",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 5.348h1.778m14.222 0h-1.778m-12.444 0 .683 13.751A2 2 0 0 0 8.46 21h7.082a2 2 0 0 0 1.998-1.9l.683-13.752m-12.444 0h3.555m8.89 0h-3.556m-5.334 0V4a1 1 0 0 1 1-1h3.334a1 1 0 0 1 1 1v1.348m-5.334 0h5.334M8.444 7.696 9 18.652m3-10.956v10.956m3.556-10.956L15 18.652",
    stroke: "#747F88",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgDelete;